import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import resumeData from "../../utils/resume-data";
import Send from "@material-ui/icons/Send";
import { LinkedIn, GitHub } from '@material-ui/icons';
import Alerts from "./Alerts";
import emailjs from 'emailjs-com';


const useStyles = makeStyles((theme) => ({
    contactContainer: {
        background: "black",
        height: "85%",
        flexGrow: 1,
        paddingTop: '5rem',
        '@media (max-width:600px)': {
            paddingTop: '0.2rem',
        },
    },
    heading: {
        color: "whitesmoke",
        textAlign: "left",
        marginBottom: "1rem",
        fontSize: '2.5rem',
        '@media (max-width:600px)': {
            fontSize: '1.5rem',
        },
    },
    heading2: {
        color: "#ccc",
        textAlign: "left",
        fontStyle: 'italic',
        lineHeight: 2,
        fontWeight: 300,
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, 
        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        marginBottom: "1rem",
        display: 'flex',
        alignItems: "baseline",
        flexWrap: 'wrap',
        '@media (max-width:600px)': {
            fontSize: '1.1rem',
        },
    },
    btn: {
        textTransform: 'lowercase',
        fontStyle: 'italic',
        color: "orange",
        fontSize: '1.2rem',
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, 
        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        fontWeight: 300,
        '@media (max-width:600px)': {
            fontSize: '1.1rem',
        },

    },
    icon: {
        margin: 0,
        padding: 0,
        alignSelf: 'baseline',
    },
    form: {
        maxWidth: 450,
        '@media (max-width:600px)': {
            width: '90%',
            marginTop: '2rem',
            padding: '1rem',
        },
        '@media (min-width:1200px)': {
            // paddingTop: '2rem',
            // top: "50%",
            // left: "50%",
            // transform: "translate(-95%, -99%)",
            // position: "absolute",
            maxWidth: 750,
        },
    },
    input: {
        color: "whitesmoke",
        '@media (max-width:600px)': {
            fontSize: '1rem',
        },
    },
    button: {
        marginTop: "1rem",
        color: "orange",
        borderColor: "grey",
        fontStyle: "italic",
        marginBottom: '2rem',
    },
    field: {
        margin: "1rem 0rem",
    },

}));

const InputField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "grey",
        },
        "& label": {
            color: "whitesmoke",
            '@media (max-width:600px)': {
                fontSize: '0.9rem',
            },
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "grey",
            },
            "&:hover fieldset": {
                borderColor: "coffee",
            },
            "&.Mui-focused fieldset": {
                color: "whitesmoke",
                borderColor: "grey",
            },
        },
    },
})(TextField);


const Contact = () => {
    const [open, setOpen] = useState(false);
    const [alertMsg, setAlertMsg] = useState('');
    const [severity, setSeverity] = useState('');
    const classes = useStyles();

    function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm(`${process.env.REACT_APP_SER_ID}`, 'template_9tigcju', e.target, `${process.env.REACT_APP_EMAILJS_ID}`)
            .then((result) => {
                if (result.status === 200) {
                    setOpen(true)
                    setAlertMsg('Form submission Success');
                    setSeverity('success')
                }
                else {
                    setOpen(true)
                    setAlertMsg('Submission Failed, Try again!');
                    setSeverity('warning')
                }
            }, (error) => {
                console.log(error);
                setOpen(true)
                setAlertMsg(error.text);
                setSeverity('error')
            });
        e.target.reset()
    }

    return (
        <div component="div" className={classes.contactContainer}>
            <Grid container justify="center">
                <Box component="form" className={classes.form} onSubmit={sendEmail}>
                    <Typography className={classes.heading}>
                        Let's Connect...
                    </Typography>
                    <Typography variant="h6" className={classes.heading2}>
                        Submit the form below to get in touch with me or email me at
                        <Button
                            className={classes.btn}
                            target="_blank"
                            href="mailto:{resumeData.github}">{resumeData.email}</Button>
                    </Typography>
                    <Typography variant="h6" className={classes.heading2}>
                        Feel free to call me or leave a voicemail at {resumeData.phone}
                    </Typography>
                    <Typography variant="h6" className={classes.heading2}>
                        You can follow me on GitHub or LinkedIn
                        <Button
                            className={classes.btn}
                            target="_blank"
                            rel="noopener"
                            aria-label="Github"
                            href={resumeData.github}>
                            <GitHub className={classes.icon} />
                        </Button>
                        <Button
                            className={classes.btn}
                            target="_blank"
                            rel="noopener"
                            aria-label="LinkedIn"
                            variant="outlined"
                            href={resumeData.linkedin}>
                            <LinkedIn className={classes.icon} />
                        </Button>
                    </Typography>
                    <InputField
                        fullWidth={true}
                        label="Name"
                        aria-label="Name"
                        type="text"
                        name='name'
                        required
                        variant="outlined"
                        inputProps={{ className: classes.input }}
                    />
                    <InputField
                        fullWidth={true}
                        label="Email"
                        aria-label="Email"
                        variant="outlined"
                        required
                        name='email'
                        type='email'
                        inputProps={{ className: classes.input }}
                        className={classes.field}
                    />
                    <InputField
                        fullWidth={true}
                        label="Message"
                        aria-label="Message"
                        name='message'
                        required
                        variant="outlined"
                        multiline
                        rows={4}
                        inputProps={{ className: classes.input }}
                    />
                    <Button
                        variant="outlined"
                        aria-label="submit"
                        endIcon={<Send />}
                        type="submit"
                        className={classes.button}>
                        Submit
                    </Button>
                </Box>
            </Grid>
            <Alerts
                alertMsg={alertMsg}
                setOpen={setOpen}
                severity={severity}
                open={open} />
        </div>
    );
};

export default Contact;

// set background image for large screens